export const en = {
    archive: 'Full archive',
    load: 'Show more'
};
